import React from 'react';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { ChevronRight } from '../icons';
import CmsLinks from '../ui/CmsLinks';
import { WPLink } from '@/data/wp/operations/queries/fragments/link';
import styled from '@mui/system/styled';
import Grid from '@mui/material/Grid';

interface BreadcrumbProps {
  breadcrumbs: {
    links: WPLink[];
  }[];
}

const StyledBreadcrumbs = styled(Breadcrumbs)({
  '.MuiBreadcrumbs-separator': {
    'svg': {
      width: '10px',
      height: '10px',
    }
  }
});

const StyledCmsLinks = styled(CmsLinks)({
  '.MuiLink-root': {
    color: '#545454',
    fontSize: '12px',
    letterSpacing: '-0.16px',
    lineHeight: '24px',
    textDecoration: 'unset'
  }
});

const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbs }) => {
  return <Grid item xs={12} sx={{ marginBottom: '21px' }}>
    <StyledBreadcrumbs
        separator={<ChevronRight />}
        aria-label="breadcrumb"
      >
        {breadcrumbs && breadcrumbs.length > 0 && breadcrumbs.map((singleBreadcrumb, index) => <StyledCmsLinks key={index} data={singleBreadcrumb.links} direction="row"></StyledCmsLinks>)
      }
    </StyledBreadcrumbs>
  </Grid>
}

export default Breadcrumb;
